import { Component, Input } from '@angular/core';
import { ModalData } from '../../models/modal-data.model';

import { IonicModule } from '@ionic/angular/lazy';

@Component({
    selector: 'web-modal-card',
    templateUrl: './modal-card.component.html',
    styleUrls: ['./modal-card.component.scss'],
    imports: [IonicModule],
})
export class ModalCardComponent {
    @Input() modalData?: ModalData;
}
